module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.infoMessage || _vm.errorMessage) ? _c('div', {
    staticClass: "container mb-20"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "m-message--error"
  }, [_c('span', {
    staticClass: "m-message--error__description",
    attrs: {
      "role": "alert"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.errorMessage)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-close",
    on: {
      "click": _vm.closeMessage
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.infoMessage) ? _c('div', {
    staticClass: "m-message--info"
  }, [_c('span', {
    staticClass: "m-message--info__description",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.infoMessage))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-close",
    on: {
      "click": _vm.closeMessage
    }
  })]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d7072a8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/checkout/components/molecules/Message.vue
// module id = 529
// module chunks = 2